import { toast } from "@assetwatch/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workClient } from "../clients/workClient";
import { useWorkScope } from "../components/WorkScopeProvider";
import type { CreateWorkRequestInput } from "../types/workRequest";
import { createWorkRequestResponseSchema } from "../types/workRequestApi";

export function useCreateWorkRequestMutation() {
  const { selectedCustomer, selectedFacility } = useWorkScope();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CreateWorkRequestInput) => {
      if (!selectedCustomer || !selectedFacility) {
        throw new Error("A customer and facility must be selected.");
      }

      const response = await workClient.v1.customers[":customerId"].facilities[
        ":facilityId"
      ].requests.$post({
        param: {
          customerId: selectedCustomer.id,
          facilityId: selectedFacility.id,
        },
        json: input,
      });

      if (!response.ok) {
        throw new Error(
          `Failed to create the Work Request: ${response.status}`,
        );
      }

      return createWorkRequestResponseSchema.parse(await response.json());
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: ["work-requests"] });
      toast.add(`Work Request ${data.requestNumber} created.`, {
        icon: true,
      });
    },
    onError: () => {
      toast.error("Unable to create the Work Request. Try again.", {
        icon: true,
      });
    },
  });
}
